import { memo } from 'react';
// @mui
import { Box, BoxProps } from '@mui/material';
//

// ----------------------------------------------------------------------

function TerraplanIllustration({ ...other }: BoxProps) {
  return (
    <Box {...other}>
      <svg width="100%" height="100%" viewBox="0 0 880 260" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#FA5D51"
          opacity="1.000000"
          stroke="none"
          d="
M 352.469 192 C 432 1 432.5 1 432.75 1 c 78.475 186.767 79.259 188.53 80.136 190.651 c -20.886 0 -36.886 0 -42.429 -0.037 c -24.836 -70.647 -30.912 -87.92 -37.424 -106.432 C 397.475 184.086 395.663 188.016 394 192 h -41.531"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M496.488464,151.041412
	C494.176788,147.150650 492.331757,143.233627 490.739624,139.114288
	C500.314301,138.941315 509.636108,138.995728 518.957886,138.996201
	C633.992798,139.002029 749.027771,139.000000 864.531372,139.000000
	C865.000000,142.692902 865.000000,146.385818 865.000000,150.539368
	C742.318359,151.005051 619.636719,151.010117 496.488464,151.041412
z"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M373.392853,138.970154
	C372.294922,142.770721 370.739594,146.586578 369.016724,150.721695
	C246.545242,151.027313 124.241280,151.013657 1.468657,151.000000
	C1.000000,147.307098 1.000000,143.614182 1.000000,139.460632
	C124.978485,138.995148 248.956970,138.990295 373.392853,138.970154
z"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M253.708496,126.963852
	C251.244247,124.421089 248.915497,122.084938 247.211197,119.358444
	C237.589645,103.966263 228.112427,88.483810 218.608734,73.018158
	C218.020844,72.061478 217.626999,70.985558 216.684998,68.999977
	C220.853561,68.999977 224.406036,69.090836 227.952530,68.983612
	C240.592911,68.601471 251.314301,62.531490 253.682907,48.306057
	C255.855042,35.260635 245.569138,19.970766 231.252075,19.942968
	C223.308426,19.927547 215.366791,19.309134 207.422134,19.020212
	C205.806961,18.961472 204.182404,19.161282 202.083130,19.265738
	C202.083130,55.135056 202.083130,90.696770 202.083130,126.627296
	C198.017471,126.627296 194.439224,126.627296 190.427887,126.627296
	C190.427887,87.029991 190.427887,47.353584 190.427887,7.000000
	C201.903778,7.000000 213.335617,6.896874 224.764114,7.048026
	C229.707870,7.113411 234.740555,7.209206 239.567184,8.145350
	C256.016785,11.335810 266.937927,27.998419 267.146698,43.064209
	C267.290894,53.472950 265.303833,62.699936 258.209900,70.583733
	C253.207062,76.143562 247.251083,79.826225 238.859848,80.557861
	C248.503342,96.100304 257.741577,110.989571 267.669342,126.990204
	C262.518158,126.990204 258.325256,126.990204 253.708496,126.963852
z"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M362.133301,127.000000
	C357.770203,127.652428 355.308594,126.079811 353.224274,122.641434
	C342.951569,105.695137 332.439880,88.893799 322.039581,72.024597
	C321.633179,71.365471 321.502991,70.536064 321.167847,69.565178
	C327.412354,69.017677 333.540131,69.037910 339.421661,67.844543
	C350.455505,65.605789 358.197418,56.053680 357.926880,45.161167
	C357.623413,32.943821 350.846222,22.543941 339.457214,20.555641
	C328.783234,18.692162 317.709900,19.115919 306.244751,18.502806
	C306.244751,54.961891 306.244751,90.540482 306.244751,126.558182
	C302.033325,126.558182 298.339172,126.558182 294.318115,126.558182
	C294.318115,86.903732 294.318115,47.327106 294.318115,7.000000
	C298.156830,7.000000 301.920563,7.000000 305.684296,7.000000
	C314.517334,7.000000 323.354309,7.170632 332.182587,6.965469
	C352.289032,6.498206 366.254395,17.259666 370.293732,36.152393
	C374.262970,54.717041 367.985107,71.979355 349.353577,79.270096
	C347.571198,79.967560 345.604553,80.194153 343.015320,80.806931
	C352.506683,96.104851 361.748199,111.000122 371.675079,127.000000
	C368.008179,127.000000 365.298859,127.000000 362.133301,127.000000
z"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M105.000000,30.022688
	C105.000000,40.140781 105.000000,49.761868 105.000000,59.895523
	C122.103142,59.895523 138.683456,59.895523 155.627716,59.895523
	C155.627716,64.318237 155.627716,68.229691 155.627716,72.843781
	C139.013885,72.843781 122.310860,72.843781 105.310379,72.843781
	C105.310379,87.112465 105.310379,100.686913 105.310379,114.785995
	C121.990990,114.785995 138.570175,114.785995 155.572067,114.785995
	C155.572067,118.994423 155.572067,122.687691 155.572067,126.694542
	C134.548126,126.694542 113.641228,126.694542 92.366562,126.694542
	C92.366562,87.004364 92.366562,47.434631 92.366562,7.431903
	C113.318169,7.431903 134.342987,7.431903 155.685303,7.431903
	C155.685303,11.100647 155.685303,14.679119 155.685303,18.781277
	C139.016327,18.781277 122.435890,18.781277 105.000000,18.781277
	C105.000000,22.697392 105.000000,26.111534 105.000000,30.022688
z"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M18.002758,7.000000
	C33.117409,7.000000 47.732861,7.000000 62.671890,7.000000
	C62.671890,11.071549 62.671890,14.649386 62.671890,18.749521
	C54.718906,18.749521 46.804554,18.749521 38.218971,18.749521
	C38.218971,54.938007 38.218971,90.619141 38.218971,126.647324
	C33.978012,126.647324 30.399702,126.647324 26.144217,126.647324
	C26.144217,90.991684 26.144217,55.309139 26.144217,19.112453
	C17.906439,19.112453 10.323905,19.112453 2.376995,19.112453
	C2.376995,15.026133 2.376995,11.447947 2.376995,7.000000
	C7.335182,7.000000 12.419373,7.000000 18.002758,7.000000
z"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M786.453674,8.101231
	C807.846375,42.043579 828.966370,75.690575 850.068359,109.308975
	C850.068359,75.225410 850.068359,41.433575 850.068359,7.323816
	C853.285706,7.323816 857.218567,7.323816 861.577759,7.323816
	C861.577759,47.000557 861.577759,86.693550 861.577759,126.992371
	C857.187317,126.992371 852.888855,127.198830 848.632996,126.864365
	C847.384827,126.766273 845.885071,125.367111 845.128784,124.168068
	C825.395203,92.882492 805.747437,61.542812 786.071655,30.220774
	C785.066223,28.620256 783.943665,27.093395 782.500000,24.983166
	C782.500000,59.299995 782.500000,92.787758 782.500000,126.637833
	C778.660828,126.637833 774.749023,126.637833 770.416016,126.637833
	C770.416016,86.985291 770.416016,47.292633 770.416016,6.717426
	C775.790527,7.088500 780.985718,7.447192 786.453674,8.101231
z"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M672.689453,76.601822
	C681.552002,53.790699 690.205933,31.314247 699.040405,8.909013
	C699.540161,7.641546 701.460510,6.256642 702.826904,6.135468
	C706.940369,5.770685 711.106873,6.003928 715.326599,6.003928
	C730.726807,45.885353 746.023987,85.500046 761.649170,125.964050
	C757.017090,125.964050 753.345154,126.348892 749.828918,125.776611
	C748.401550,125.544304 746.791809,123.434654 746.156189,121.826912
	C742.275574,112.011208 738.775635,102.043694 734.806824,92.265587
	C734.213318,90.803139 731.834961,89.165710 730.258423,89.141289
	C715.105225,88.906517 699.944580,89.149460 684.791626,88.905296
	C680.522766,88.836510 680.066284,91.762764 679.045105,94.414421
	C675.606506,103.342957 672.080750,112.246666 668.998047,121.299408
	C667.686340,125.151215 665.656616,126.546402 661.739807,126.056076
	C659.321899,125.753387 656.835205,125.999992 653.391174,125.999992
	C659.983887,109.095612 666.251892,93.023743 672.689453,76.601822
M700.872925,36.370903
	C695.919678,49.721676 690.966431,63.072449 685.971741,76.534737
	C700.684448,76.534737 714.676331,76.534737 728.988098,76.534737
	C721.774841,57.489841 714.757690,38.962673 707.303467,19.281706
	C704.936462,25.546707 703.031616,30.588400 700.872925,36.370903
z"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M501.000000,37.000000
	C501.000000,26.881018 501.000000,17.262037 501.000000,7.212099
	C515.091553,7.212099 528.691772,6.891924 542.261475,7.394833
	C546.698059,7.559258 551.562256,9.036044 555.350159,11.352690
	C565.238525,17.400341 571.694153,25.853340 572.100037,38.250538
	C572.456360,49.133667 570.660889,58.928246 562.599243,66.960915
	C555.011536,74.521446 545.423706,76.436760 535.395142,76.930183
	C528.134521,77.287415 520.842163,76.999893 513.063354,76.999893
	C513.063354,93.815979 513.063354,110.055367 513.063354,126.643875
	C508.984955,126.643875 505.406799,126.643875 501.000000,126.643875
	C501.000000,96.952660 501.000000,67.226334 501.000000,37.000000
M541.185120,62.979343
	C552.003601,60.861946 557.578918,54.211914 558.883179,43.335651
	C559.746643,36.135098 554.651733,25.153017 547.999084,22.607599
	C536.804382,18.324322 525.102417,18.654568 513.320435,19.262072
	C513.320435,34.339294 513.320435,48.910934 513.320435,64.431496
	C522.559265,63.944309 531.445801,63.475700 541.185120,62.979343
z"
        />
        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M604.000000,102.983887
	C604.000000,107.107918 604.000000,110.735535 604.000000,114.873505
	C618.412415,114.873505 632.327820,114.873505 646.617432,114.873505
	C646.617432,118.964287 646.617432,122.543861 646.617432,126.564453
	C628.363953,126.564453 610.002991,126.564453 591.319336,126.564453
	C591.319336,86.907265 591.319336,47.336220 591.319336,7.382190
	C595.296814,7.382190 599.206726,7.382190 604.000000,7.382190
	C604.000000,39.012573 604.000000,70.750031 604.000000,102.983887
z"
        />

        <path
          fill="#B2B3B3"
          opacity="1.000000"
          stroke="none"
          d="
M413.669006,139.079437
	C426.306854,138.938293 438.621063,138.962402 451.392639,138.972366
	C453.212921,142.735031 454.575867,146.511841 455.900513,150.668900
	C440.605347,151.038940 425.348480,151.028748 409.637329,151.027344
	C410.570496,147.105621 411.957947,143.175140 413.669006,139.079437
z"
        />
      </svg>
    </Box>
  );
}

export default memo(TerraplanIllustration);
